import request from './request'

export interface UpdateChecklistStatusParams {
  id: number
  status: number
}

export interface UpdateChecklistStatusResponse {
  code: number
  msg: string
  data?: unknown
}

export function updateChecklistStatus(
  params: UpdateChecklistStatusParams,
): Promise<UpdateChecklistStatusResponse> {
  return request.post('/api/admin/checklist/update-status', params)
}
